export interface ExternalSourceRule {
  name: string;
  baseRepositories: string[];
  module: string;
  owner: string;
  repo: string;
  moduleLockFiles: string[];
  surfacePrefixes: string[];
  markerPrefixes: string[];
  reason: string;
}

const NEXUSCRM_GO_MODULE_LOCK_FILES = [
  'backend/go.mod',
  'backend/distributions/go.mod',
  'shared/go.mod',
  'nexuscrm-analytics/go.mod',
  'nexuscrm-audit/go.mod',
  'nexuscrm-auth/go.mod',
  'nexuscrm-automation/go.mod',
  'nexuscrm-db/go.mod',
  'nexuscrm-events/go.mod',
  'nexuscrm-files/go.mod',
  'nexuscrm-kernel/go.mod',
  'nexuscrm-metadata/go.mod',
  'nexuscrm-outbound/go.mod',
  'nexuscrm-permissions/go.mod',
  'nexuscrm-persistence/go.mod',
  'nexuscrm-records/go.mod',
  'nexuscrm-storage/go.mod',
];

export const EXTERNAL_SOURCE_RULES: ExternalSourceRule[] = [
  {
    name: 'api-host',
    baseRepositories: ['pingcap-inc/NexusCRM'],
    module: 'github.com/pingcap-inc/nexuscrm-api-host',
    owner: 'pingcap-inc',
    repo: 'nexuscrm-api-host',
    moduleLockFiles: NEXUSCRM_GO_MODULE_LOCK_FILES,
    surfacePrefixes: [
      'backend/internal/host/adapters/apihost/',
      'backend/internal/interfaces/origin/',
      'backend/internal/interfaces/rest/',
      'backend/internal/interfaces/middleware/',
      'backend/pkg/serverruntime/',
    ],
    markerPrefixes: [
      'backend/internal/interfaces/origin/',
      'backend/internal/interfaces/rest/requestparams/',
      'backend/internal/host/adapters/apihost/',
      'backend/pkg/serverruntime/',
    ],
    reason: 'api-host dependency PRs review live API host implementation behind the external module pin.',
  },
  {
    name: 'connectors',
    baseRepositories: ['pingcap-inc/NexusCRM'],
    module: 'github.com/pingcap-inc/nexuscrm-connectors',
    owner: 'pingcap-inc',
    repo: 'nexuscrm-connectors',
    moduleLockFiles: NEXUSCRM_GO_MODULE_LOCK_FILES,
    surfacePrefixes: [
      'backend/pkg/serverruntime/',
      'backend/internal/interfaces/rest/ops/',
      'backend/internal/boundary/l0_connector_ingress_guard_test.go',
    ],
    markerPrefixes: [
      'backend/pkg/serverruntime/',
      'backend/internal/interfaces/rest/ops/',
      'backend/internal/boundary/',
    ],
    reason: 'connector dependency PRs review live connector implementation behind the external module pin.',
  },
  {
    name: 'contract',
    baseRepositories: ['pingcap-inc/NexusCRM'],
    module: 'github.com/pingcap-inc/nexuscrm-contract',
    owner: 'pingcap-inc',
    repo: 'nexuscrm-contract',
    moduleLockFiles: NEXUSCRM_GO_MODULE_LOCK_FILES,
    surfacePrefixes: [
      'backend/internal/bootstrap/',
      'nexuscrm-automation/',
      'nexuscrm-db/',
      'nexuscrm-kernel/',
      'nexuscrm-records/',
      'shared/pkg/constants/',
      'shared/pkg/contract/',
      'shared/pkg/models/',
      'shared/pkg/stagetiming/',
    ],
    markerPrefixes: [
      'backend/internal/bootstrap/',
      'nexuscrm-automation/',
      'nexuscrm-db/',
      'nexuscrm-kernel/',
      'nexuscrm-records/',
      'shared/pkg/',
    ],
    reason: 'contract dependency PRs review shared DTO and pure contract facts behind the external module pin.',
  },
  {
    name: 'controlplane',
    baseRepositories: ['pingcap-inc/NexusCRM'],
    module: 'github.com/pingcap-inc/nexuscrm-controlplane',
    owner: 'pingcap-inc',
    repo: 'nexuscrm-controlplane',
    moduleLockFiles: NEXUSCRM_GO_MODULE_LOCK_FILES,
    surfacePrefixes: [
      'backend/internal/bootstrap/',
      'backend/internal/setupcmd/',
      'backend/internal/features/automationintegration/',
      'backend/internal/interfaces/rest/platform/',
      'backend/pkg/serverruntime/',
      'backend/distributions/',
    ],
    markerPrefixes: [
      'backend/internal/bootstrap/',
      'backend/internal/setupcmd/',
      'backend/internal/features/automationintegration/',
      'backend/internal/interfaces/rest/platform/',
      'backend/pkg/serverruntime/',
      'backend/distributions/',
    ],
    reason: 'controlplane dependency PRs review pack/bootstrap/apply implementation behind the external module pin.',
  },
];

export function rulesForBaseRepository(baseRepository: string): ExternalSourceRule[] {
  return EXTERNAL_SOURCE_RULES.filter((rule) => (
    rule.baseRepositories.length === 0 || rule.baseRepositories.includes(baseRepository)
  ));
}

